import type { DeliveryAction } from '@/hooks/delivery/useDeliveryAction';
import type { GetMonitorDeliveryDetailResponse } from '../../../../types';
import { DeliveryActions } from '../../../delivery-actions/delivery-actions';
import styles from './drawer-footer.module.scss';

interface DrawerFooterProps {
  detail: GetMonitorDeliveryDetailResponse;
  onActionFinished: (action: DeliveryAction) => void;
}

export function DrawerFooter({ detail, onActionFinished }: DrawerFooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={styles.actions}>
        <DeliveryActions
          delivery={detail}
          variant="filled"
          onActionFinished={onActionFinished}
        />
      </div>
    </footer>
  );
}
